<template>
    <v-content>
        <v-container fluid
                     class="app_container">

            <v-layout fill-height column>
                <v-flex aign-self-start shrink>
                    <v-layout row wrap justify-space-between align-center xs12
                              class="app_header">
                        <v-flex pa-3 xs6 class="container_logo">
                            <v-img transition="false" :src="logo"></v-img>
                        </v-flex>
                      <v-flex>
                         <v-layout row justify-end>
                           <v-flex shrink>
                             <current-sharing-button></current-sharing-button>
                           </v-flex>
                           <v-flex shrink>
                             <v-toolbar-side-icon
                                 @click.stop="showMenu= !showMenu">
                               <v-icon x-large color="primary">
                                 mdi-dots-horizontal
                               </v-icon>
                             </v-toolbar-side-icon>

                             <v-navigation-drawer
                                 v-model="showMenu"
                                 clipped
                                 fixed
                                 app
                                 right
                                 width="140"
                                 class="menubackground container_menu">
                               <v-layout column wrap align-center>
                                 <v-flex class="go-back" xs12>
                                   <v-icon x-large
                                           @click.stop="showMenu= false">
                                     mdi-chevron-right
                                   </v-icon>
                                 </v-flex>
                               </v-layout>
                               <v-layout d-block class="pa-0 menu_block">
                                 <v-list class="list-menu">
                                   <router-link :to="{name: 'account'}"
                                                active-class="button-menu-active">
                                     <v-list-tile class="menu-field">
                                       <v-list-tile-content>
                                         <v-list-tile-title>
                                           {{$vuetify.t("$vuetify.Application.account")
                                             | uppercase}}
                                         </v-list-tile-title>
                                       </v-list-tile-content>
                                       <v-list-tile-action>
                                         <v-icon size="21">
                                           mdi-account-circle-outline
                                         </v-icon>
                                       </v-list-tile-action>
                                     </v-list-tile>
                                   </router-link>
                                   <router-link :to="{name: 'statistics'}"
                                                active-class="button-menu-active">
                                     <v-list-tile class="menu-field">
                                       <v-list-tile-content>
                                         <v-list-tile-title>
                                           {{$vuetify.t("$vuetify.Application.statistics")
                                             | uppercase}}
                                         </v-list-tile-title>
                                       </v-list-tile-content>
                                       <v-list-tile-action>
                                         <v-icon size="21">
                                           mdi-chart-line
                                         </v-icon>
                                       </v-list-tile-action>
                                     </v-list-tile>
                                   </router-link>
                                   <v-list-tile class="menu-field"
                                                @click="showPopupRules = true">
                                     <v-list-tile-content>
                                       <v-list-tile-title>
                                         {{$vuetify.t("$vuetify.Application.rules")
                                           | uppercase}}
                                       </v-list-tile-title>
                                     </v-list-tile-content>
                                     <v-list-tile-action>
                                       <v-icon size="21">
                                         mdi-script-text-outline
                                       </v-icon>
                                     </v-list-tile-action>
                                   </v-list-tile>
                                   <v-list-tile class="menu-field"
                                                @click="executeLogout()">
                                     <v-list-tile-content>
                                       <v-list-tile-title>
                                         {{$vuetify.t("$vuetify.Application.logout")
                                           | uppercase}}
                                       </v-list-tile-title>
                                     </v-list-tile-content>
                                     <v-list-tile-action>
                                       <v-icon size="21">mdi-logout
                                       </v-icon>
                                     </v-list-tile-action>
                                   </v-list-tile>
                                 </v-list>

                               </v-layout>
                               <v-layout column wrap align-center
                                         class="d-block version-block">
                                 <v-flex class="version" xs12>
                                   {{$vuetify.t("$vuetify.Application.version")}}
                                   {{version}}
                                 </v-flex>
                               </v-layout>

                             </v-navigation-drawer>


                           </v-flex>
                         </v-layout>
                      </v-flex>

                    </v-layout>
                    <v-layout align-center justify-start row wrap
                              class="customer_header">
                        <v-flex shrink class="customer_name coloricon--text">
                            <ApolloQuery
                                    client-id="clientPrivate"
                                    :query="require('../../graphql/queries/currentCustomer.gql')">
                                <template
                                        v-slot="{ result: { loading, error, data } }">
                                    <div v-if="data" class="result apollo">{{
                                        data.customer.name | uppercase }}
                                    </div>

                                    <v-dialog v-if="data"
                                              v-model="showPopupRules"
                                              width="100%">
                                        <v-card>

                                            <v-card-text v-if="data"
                                                         v-html="data.customer.bikeSharingRoles"
                                                         class="text-xs-justify">
                                            </v-card-text>

                                            <v-divider></v-divider>
                                            <v-card-actions>
                                                <v-spacer></v-spacer>
                                                <v-btn color="accent"
                                                       flat
                                                       @click="showPopupRules = false">
                                                    {{$vuetify.t("$vuetify.Application.closePopupRules")}}
                                                </v-btn>
                                            </v-card-actions>
                                        </v-card>
                                    </v-dialog>
                                </template>
                            </ApolloQuery>
                        </v-flex>
                    </v-layout>
                </v-flex>
                <v-flex grow>
                    <v-layout :fill-height="true" xs12 class="app_body">
                        <router-view></router-view>
                    </v-layout>
                </v-flex>
                <v-flex aign-self-end shrink>
                    <v-layout justify-center align-center align-content-center
                              row xs12 class="app_footer">
                        <v-flex>
                            <v-btn block
                                   color="transparent"
                                   active-class="button-active"
                                   class="action-button"
                                   :to="{name: 'picks-up'}">
                                <v-flex>
                                    <div class="d-inline-block">
                                        <svg xmlns="http://www.w3.org/2000/svg"
                                             width="34.249" height="29.357"
                                             viewBox="0 0 34.249 29.357">
                                            <g id="Group_56"
                                               data-name="Group 56"
                                               transform="translate(-2.481 -9.292)">
                                                <g id="Group_55"
                                                   data-name="Group 55"
                                                   transform="translate(2.481 9.292)">
                                                    <path id="Path_68"
                                                          data-name="Path 68"
                                                          d="M36.725,55.942,34.887,41.6a.945.945,0,0,0-.613-.757l-3.1-1.117c-.288.541-.577,1.117-.865,1.658l2.775,1.009,1.586,12.361-6.6-2.126-.469-7.28a2.633,2.633,0,0,1-1.081.216,2.561,2.561,0,0,1-.757-.108l.469,7.208-5.766,2.09V42.319l2.306-.937-.865-1.658-2.306.973-6.343-2.631a1.116,1.116,0,0,0-.685-.036l-7.64,2.811a.957.957,0,0,0-.613.757L2.488,55.942a.915.915,0,0,0,.324.829.952.952,0,0,0,.865.18l8.253-2.667,7.352,2.667a.893.893,0,0,0,.613,0l7.352-2.667L35.5,56.951a.794.794,0,0,0,.288.036.818.818,0,0,0,.577-.216A.943.943,0,0,0,36.725,55.942ZM11.1,52.626l-6.6,2.126L6.092,42.391l5.8-2.09Zm7.568,2.126L12.9,52.662l.793-12.4,4.973,2.054Z"
                                                          transform="translate(-2.481 -27.648)"
                                                          fill="#eb8903"/>
                                                    <path id="Path_69"
                                                          data-name="Path 69"
                                                          d="M59.236,24.936a.787.787,0,0,0,1.406,0s3.28-6.415,4.036-7.929a5.311,5.311,0,0,0-7.136-7.136A5.351,5.351,0,0,0,55.2,17.007C56.5,19.53,59.236,24.936,59.236,24.936Zm.721-12.758A2.523,2.523,0,1,1,57.434,14.7,2.507,2.507,0,0,1,59.957,12.178Z"
                                                          transform="translate(-35.84 -9.292)"
                                                          fill="#eb8903"/>
                                                </g>
                                            </g>
                                        </svg>
                                    </div>
                                </v-flex>
                            </v-btn>
                        </v-flex>
                        <v-flex>
                            <v-btn block
                                   color="transparent"
                                   active-class="button-active"
                                   class="action-button"
                                   :to="{name: 'stations'}">
                                <v-flex>
                                    <div class="d-inline-block">
                                        <svg id="Group_57" data-name="Group 57"
                                             xmlns="http://www.w3.org/2000/svg"
                                             width="28.1" height="28.1"
                                             viewBox="0 0 28.1 28.1">
                                            <path id="Path_70"
                                                  data-name="Path 70"
                                                  d="M28.684,13.756H12.878a.878.878,0,0,1,0-1.756H28.684a.878.878,0,1,1,0,1.756Z"
                                                  transform="translate(-1.463 -1.463)"
                                                  fill="#eb8903"/>
                                            <path id="Path_71"
                                                  data-name="Path 71"
                                                  d="M28.684,16.756H12.878a.878.878,0,0,1,0-1.756H28.684a.878.878,0,1,1,0,1.756Z"
                                                  transform="translate(-1.463 -1.828)"
                                                  fill="#eb8903"/>
                                            <path id="Path_72"
                                                  data-name="Path 72"
                                                  d="M24.294,19.756H12.878a.878.878,0,1,1,0-1.756H24.294a.878.878,0,1,1,0,1.756Z"
                                                  transform="translate(-1.463 -2.194)"
                                                  fill="#eb8903"/>
                                            <path id="Path_73"
                                                  data-name="Path 73"
                                                  d="M28.684,24.756H12.878a.878.878,0,0,1,0-1.756H28.684a.878.878,0,1,1,0,1.756Z"
                                                  transform="translate(-1.463 -2.803)"
                                                  fill="#eb8903"/>
                                            <path id="Path_74"
                                                  data-name="Path 74"
                                                  d="M28.684,27.756H12.878a.878.878,0,0,1,0-1.756H28.684a.878.878,0,1,1,0,1.756Z"
                                                  transform="translate(-1.463 -3.169)"
                                                  fill="#eb8903"/>
                                            <path id="Path_75"
                                                  data-name="Path 75"
                                                  d="M16.391,30.756H12.878a.878.878,0,0,1,0-1.756h3.512a.878.878,0,1,1,0,1.756Z"
                                                  transform="translate(-1.463 -3.535)"
                                                  fill="#eb8903"/>
                                            <path id="Path_76"
                                                  data-name="Path 76"
                                                  d="M28.684,2.756H12.878a.878.878,0,0,1,0-1.756H28.684a.878.878,0,1,1,0,1.756Z"
                                                  transform="translate(-1.463 -0.122)"
                                                  fill="#eb8903"/>
                                            <path id="Path_77"
                                                  data-name="Path 77"
                                                  d="M28.684,5.756H12.878a.878.878,0,1,1,0-1.756H28.684a.878.878,0,1,1,0,1.756Z"
                                                  transform="translate(-1.463 -0.488)"
                                                  fill="#eb8903"/>
                                            <path id="Path_78"
                                                  data-name="Path 78"
                                                  d="M20.781,8.756h-7.9a.878.878,0,0,1,0-1.756h7.9a.878.878,0,0,1,0,1.756Z"
                                                  transform="translate(-1.463 -0.853)"
                                                  fill="#eb8903"/>
                                            <path id="Path_79"
                                                  data-name="Path 79"
                                                  d="M6.589,8.781h-4.4A2.195,2.195,0,0,1,0,6.589v-4.4A2.195,2.195,0,0,1,2.192,0h4.4A2.195,2.195,0,0,1,8.781,2.192v4.4A2.195,2.195,0,0,1,6.589,8.781Zm-4.4-7.025a.437.437,0,0,0-.436.436v4.4a.437.437,0,0,0,.436.436h4.4a.437.437,0,0,0,.436-.436v-4.4a.437.437,0,0,0-.436-.436Z"
                                                  fill="#eb8903"/>
                                            <path id="Path_80"
                                                  data-name="Path 80"
                                                  d="M6.589,19.781h-4.4A2.195,2.195,0,0,1,0,17.589v-4.4A2.195,2.195,0,0,1,2.192,11h4.4a2.195,2.195,0,0,1,2.192,2.192v4.4A2.195,2.195,0,0,1,6.589,19.781Zm-4.4-7.025a.437.437,0,0,0-.436.436v4.4a.437.437,0,0,0,.436.436h4.4a.437.437,0,0,0,.436-.436v-4.4a.437.437,0,0,0-.436-.436Z"
                                                  transform="translate(0 -1.341)"
                                                  fill="#eb8903"/>
                                            <path id="Path_81"
                                                  data-name="Path 81"
                                                  d="M6.589,30.781h-4.4A2.195,2.195,0,0,1,0,28.589v-4.4A2.195,2.195,0,0,1,2.192,22h4.4a2.195,2.195,0,0,1,2.192,2.192v4.4A2.195,2.195,0,0,1,6.589,30.781Zm-4.4-7.025a.437.437,0,0,0-.436.436v4.4a.437.437,0,0,0,.436.436h4.4a.437.437,0,0,0,.436-.436v-4.4a.437.437,0,0,0-.436-.436Z"
                                                  transform="translate(0 -2.681)"
                                                  fill="#eb8903"/>
                                        </svg>
                                    </div>
                                </v-flex>
                            </v-btn>
                        </v-flex>
                        <v-flex>
                            <v-btn block
                                   color="transparent"
                                   active-class="button-active"
                                   class="action-button"
                                   :to="{name: 'credit'}">
                                <v-flex>
                                    <div class="d-inline-block">
                                        <svg xmlns="http://www.w3.org/2000/svg"
                                             width="33.095" height="27.727"
                                             viewBox="0 0 33.095 27.727">
                                            <g id="Group_8" data-name="Group 8"
                                               transform="translate(-2 -7)">
                                                <g id="Group_7"
                                                   data-name="Group 7"
                                                   transform="translate(25.244 22.496)">
                                                    <path id="Path_10"
                                                          data-name="Path 10"
                                                          d="M47.321,39.427V37.214a1.11,1.11,0,0,1,1.107,1.107h1.107a2.22,2.22,0,0,0-2.214-2.214V35H46.214v1.107a2.214,2.214,0,0,0,0,4.427v2.214a1.11,1.11,0,0,1-1.107-1.107H44a2.22,2.22,0,0,0,2.214,2.214v1.107h1.107V43.855a2.214,2.214,0,0,0,0-4.427Zm-2.214-1.107a1.11,1.11,0,0,1,1.107-1.107v2.214A1.11,1.11,0,0,1,45.107,38.321Zm2.214,4.427V40.534a1.107,1.107,0,0,1,0,2.214Z"
                                                          transform="translate(-44 -35)"
                                                          fill="#eb8903"/>
                                                </g>
                                                <path id="Path_11"
                                                      data-name="Path 11"
                                                      d="M43.284,32.107A5.935,5.935,0,0,1,47.6,33.933l-1.439.664,3.653,2.49.332-4.427-1.494.719A7.244,7.244,0,0,0,43.284,31,7.147,7.147,0,0,0,36.2,36.977l1.107.166A6.021,6.021,0,0,1,43.284,32.107Z"
                                                      transform="translate(-15.273 -10.718)"
                                                      fill="#eb8903"/>
                                                <path id="Path_12"
                                                      data-name="Path 12"
                                                      d="M49.439,45.8a6.019,6.019,0,0,1-5.977,5.092,5.935,5.935,0,0,1-4.317-1.826l1.439-.664-3.653-2.49L36.6,50.338l1.494-.719a7.168,7.168,0,0,0,12.452-3.542Z"
                                                      transform="translate(-15.451 -17.327)"
                                                      fill="#eb8903"/>
                                                <rect id="Rectangle_9"
                                                      data-name="Rectangle 9"
                                                      width="29.885"
                                                      height="4.427"
                                                      transform="translate(2 7)"
                                                      fill="#eb8903"/>
                                                <rect id="Rectangle_10"
                                                      data-name="Rectangle 10"
                                                      width="29.885"
                                                      height="3.321"
                                                      transform="translate(2 12.534)"
                                                      fill="#eb8903"/>
                                                <path id="Path_13"
                                                      data-name="Path 13"
                                                      d="M28.011,27.214a8.348,8.348,0,0,1,3.874.941V25H2v8.855H19.876A8.315,8.315,0,0,1,28.011,27.214ZM14.175,30.534H4.214V29.427h9.962ZM4.214,28.321V27.214H16.389v1.107Z"
                                                      transform="translate(0 -8.038)"
                                                      fill="#eb8903"/>
                                            </g>
                                        </svg>
                                    </div>
                                </v-flex>
                            </v-btn>
                        </v-flex>
                        <v-flex>
                            <v-btn block
                                   color="transparent"
                                   active-class="button-active"
                                   class="action-button"
                                   :to="{name: 'position'}">
                                <v-flex>
                                    <div class="d-inline-block">
                                        <svg id="Group_9" data-name="Group 9"
                                             xmlns="http://www.w3.org/2000/svg"
                                             width="28.5" height="28.5"
                                             viewBox="0 0 28.5 28.5">
                                            <path id="Path_14"
                                                  data-name="Path 14"
                                                  d="M14.25,22.563A8.313,8.313,0,1,0,5.938,14.25,8.312,8.312,0,0,0,14.25,22.563Zm0-11.875a3.563,3.563,0,1,0,3.563,3.563,3.563,3.563,0,0,0-3.562-3.562Zm11.816,2.375A11.878,11.878,0,0,0,15.438,2.434V.588a.6.6,0,0,0-.6-.588H13.662a.591.591,0,0,0-.6.588V2.434A11.878,11.878,0,0,0,2.434,13.063H.588a.6.6,0,0,0-.588.6v1.177a.591.591,0,0,0,.588.6H2.434A11.878,11.878,0,0,0,13.063,26.066v1.845a.6.6,0,0,0,.6.588h1.177a.591.591,0,0,0,.6-.588V26.066A11.878,11.878,0,0,0,26.066,15.438h1.845a.6.6,0,0,0,.588-.6V13.662a.591.591,0,0,0-.588-.6Z"
                                                  fill="#eb8903"
                                                  fill-rule="evenodd"/>
                                        </svg>
                                    </div>
                                </v-flex>
                            </v-btn>
                        </v-flex>
                    </v-layout>
                </v-flex>
            </v-layout>

        </v-container>
    </v-content>

</template>


<script>

    import logo from "../../assets/logo-orizontal.png"
    import {onLogout} from "../../vue-apollo"
    import {ApolloProvider} from "../../apollo-provider"
    import CurrentSharingButton from "@/components/CurrentSharingButton.vue";


    export default {
      components: {CurrentSharingButton},
      apollo: {
        currentUser: {
          client: "clientPrivate",
          fetchPolicy: 'network-only',
          query: require("../../graphql/queries/currentUser.gql"),
          update({user}){
            if (user){
              this.setGlobalCurrentLanguage(user.language);
            }
            return user;
          }
        }
      },
      data: function () {
            return {
                logo,
                showMenu: false,
                version: process.env.VUE_APP_VERSION,
                showPopupRules: false


            }
        },
        methods: {
            executeLogout() {
                onLogout(ApolloProvider.clients.clientPrivate).then(() => {
                    this.$router.push({name: "login"})
                })

            }
        }
    }
</script>


<style scoped lang="scss">


    .app_container {
        background-color: var(--v-colorbackground-base);

    }

    .app_header, .app_footer {
        background-color: var(--v-blueprimary-base);
        height: 60px;
    }

    .customer_header {
        height: 60px;
        background-color: var(--v-customerbar-base);

        .customer_name {
            font-size: 17px;
            padding: 0 15px;
        }

    }

    .app_header {
        .container_logo {
            max-width: 188px;
        }
    }

    .app_body {
        background-color: var(--v-colorbackground-base);
        overflow-y: auto;
        overflow-x: hidden;
        height: calc(100vh - 180px);
        color: var(--v-secondary-base);

        //height: 100%;
    }

    .app_footer {

        & /deep/ .action-button {
            border: none;
            box-shadow: none;

        }

        & /deep/ .button-active {
            svg {
                path, rect {
                    fill: var(--v-accent-base);
                }
            }
        }

    }

    .container_menu {
        opacity: 0.88;

        * {
            color: var(--v-primary-base);
            font-size: 14px;
            font-weight: bold;
        }

        .go-back {
            padding-top: 10px;
            width: 100%;
            height: 60px;
        }

        .menu_block {
            margin-top: 95px;
            text-align: right;

            .list-menu {
                width: 100%;

                & /deep/ a, a:active, a:focus, a:link, a:hover {
                    text-decoration: none;
                }


                .menu-field {
                    text-align: right;


                    .v-list__tile__title {
                        text-align: right;
                    }

                    .v-list__tile__action {
                        min-width: unset;
                        padding-left: 5px;

                    }

                }

            }

            .v-list__tile {
                padding-left: 9px;
                padding-right: 9px;
            }


        }

        .version-block {
            position: absolute;
            bottom: 65px;
            width: 100%;
            text-align: center;
        }


    }


</style>

<style lang="scss">

    .menu_block {
        .v-list__tile {
            padding-left: 9px;
            padding-right: 9px;
        }

    }

</style>